import ImageC from 'src/components/Image';
import style from './style.module.less';
function DisclaimerHpl() {
  return <div className={style.disclaimer}>
			<div className="d-flex">
				<div className={style.disclaimer__left}>
					<div className={style.disclaimer__header}>
						<ImageC alt="Chevron Left" src="/images/kalender-kesuburan/logoInformasi.svg" width={24} height={24} style={{
            margin: '5px'
          }} />
						<h5 style={{
            marginLeft: '10px'
          }}>Info Untuk Mama</h5>
					</div>
					<p>
						Perkiraan hari lahir ini bukanlah alat diagnosis medis ataupun pengganti konsultasi dengan dokter spesialis kandungan.
						Hasil ini hanya sebagai prediksi mandiri yang bisa Mama gunakan untuk gambaran awal.
						Untuk memastikan kondisi kehamilan dan kesehatan Mama secara menyeluruh, tetap disarankan untuk berkonsultasi langsung ke dokter.
					</p>
				</div>
			</div>
		</div>;
}
export default DisclaimerHpl;